import { useEffect } from "react";
import "./App.css";
import Header from "./component/homePage/header.jsx";
import Footer from "./component/homePage/footer.tsx";
import AnimatedBackground from "./component/homePage/background.tsx";

const inter = {
  className: "font-inter",
};

const RootLayout = ({ children }) => {
  useEffect(() => {
    document.title = "TweetInsight";
    document
      .querySelector('meta[name="description"]')
      ?.setAttribute(
        "content",
        "Analyze tweets in real-time with our advanced system using Kafka, Apache Spark, and more."
      );
  }, []);

  return (
    <div className={`${inter.className} flex flex-col min-h-screen`}>
      <Header />
      <AnimatedBackground />
      <main className="flex-grow">{children}</main>
      <Footer />
    </div>
  );
};

export default RootLayout;
